import styled from 'styled-components';
import Documentation from './Documentation';
import { colorSchema } from 'utils/style';

export default styled(Documentation)`
  .documentation {
    display: flex;
    flex-direction: column;
    padding: 2.4rem 0;
    border-bottom: 1px solid ${colorSchema('grey200')};

    &__title {
      color: ${colorSchema('grey700')};
      font-size: 1.4rem;
      margin-bottom: 0.8rem;
    }

    &__container {
      display: flex;
      flex-direction: column;
    }

    &__link {
      display: flex;
      justify-content: space-between;
    }

    &__link-title {
      color: ${colorSchema('grey800')};
      font-size: 1.6rem;
      font-weight: 500;
    }

    &__link-button {
      align-items: center;
      background: none;
      border: 0;
      display: flex;
      cursor: pointer;
      height: 20px;
      justify-content: center;
      padding: 0;
      width: 20px;

      &:hover {
        &__link-icon {
          fill: ${colorSchema('primary900')};
        }
      }
    }

    &__link-icon {
      fill: ${colorSchema('primary500')};
      &--loading {
        animation: rotate 1s infinite linear;
        height: 16px;
        stroke: ${colorSchema('primary500')};
        width: 16px;
      }
    }
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
